import styled from 'styled-components'
import { COLORS, SPACING, TYPOGRAPHY } from 'utils'

export const ClockImage = styled.img`
  && {
    max-width: 54px;
    height: auto;
  }
`

interface TextClockImageProps {
  color?: string
}

export const TextClockImage = styled.span<TextClockImageProps>`
  font-family: Arial;
  font-size: ${TYPOGRAPHY.bodySize14};
  line-height: 19.5px;
  margin-top: ${SPACING.spacing5};
  color: ${({ color }) => (color ? color : COLORS.black)};
  strong {
    font-size: ${TYPOGRAPHY.bodySize16};
  }
`
